var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 66,
    viewBox: "0 0 87 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_179_5797)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M46.8552 1.60619C46.8552 -5.5564 53.359 -11.4126 61.4256 -11.4126C69.4923 -11.4126 75.9961 -5.60145 75.9961 1.60619C75.9961 8.81384 69.4923 14.625 61.4256 14.625C53.3589 14.625 46.8552 8.81384 46.8552 1.60619Z",
    fill: "url(#paint0_radial_179_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2239 20.4805L59.9131 1.74059L62.686 1.74059L61.2239 20.4805Z",
    fill: "#8B50E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3752 -16.9996L62.686 1.74023L59.9131 1.74023L61.3752 -16.9996Z",
    fill: "#8B50E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3014 1.69947L61.3252 0.528218L61.3252 3.00586L40.3014 1.69947Z",
    fill: "#8B50E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.2983 1.83461L61.3249 3.00586L61.3249 0.528215L82.2983 1.83461Z",
    fill: "#8B50E2"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-10.2801 26.4904C-10.2801 13.2121 1.7768 2.35571 16.7311 2.35571C31.6853 2.35572 43.7422 13.1286 43.7422 26.4904C43.7422 39.8521 31.6853 50.625 16.7311 50.625C1.77679 50.625 -10.2801 39.8521 -10.2801 26.4904Z",
    fill: "url(#paint1_radial_179_5797)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3574 61.4805L13.9273 26.7399L19.0679 26.7399L16.3574 61.4805Z",
    fill: "#8B50E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6378 -8.0003L19.0679 26.7402L13.9273 26.7402L16.6378 -8.0003Z",
    fill: "#8B50E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.4296 26.6641L16.5449 24.4928L16.5449 29.0859L-22.4296 26.6641Z",
    fill: "#8B50E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4253 26.9146L16.5442 29.0859L16.5442 24.4928L55.4253 26.9146Z",
    fill: "#8B50E2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_179_5797",
    x: -26.4297,
    y: -21,
    width: 112.728,
    height: 86.4805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_179_5797"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_179_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.4256 1.60619) rotate(-180) scale(14.5705 13.0188)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B50E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8B50E2",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8B50E2",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B50E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8B50E2",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8B50E2",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8B50E2",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8B50E2",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8B50E2",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_179_5797",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7311 26.4904) rotate(-180) scale(27.0111 24.1346)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B50E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#8B50E2",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#8B50E2",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B50E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#8B50E2",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8B50E2",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8B50E2",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#8B50E2",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#8B50E2",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleStar);
export default __webpack_public_path__ + "static/media/purple_star.3d90a11bff5e2d2ec8c62909e0db17c5.svg";
export { ForwardRef as ReactComponent };